import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec0e32c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-0 text-mild" }
const _hoisted_2 = ["id", "name", "checked"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      id: _ctx.id,
      name: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      checked: _ctx.checked,
      class: "d-none"
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _ctx.inputValue]
    ]),
    _createTextVNode(),
    _withDirectives(_createVNode(_component_FeatherIcon, {
      icon: "square",
      size: "18"
    }, null, 512), [
      [_vShow, !_ctx.inputValue]
    ]),
    _createTextVNode(),
    _withDirectives(_createVNode(_component_FeatherIcon, {
      icon: "check-square",
      size: "18",
      class: "text-blue"
    }, null, 512), [
      [_vShow, _ctx.inputValue]
    ]),
    _createTextVNode(),
    _createElementVNode("span", {
      for: _ctx.id,
      class: _normalizeClass(["ml-1 text-size-12", { 'text-blue': _ctx.inputValue }])
    }, _toDisplayString(_ctx.text), 11, _hoisted_3)
  ]))
}